export const BreakdownTypes = {
  ItemsTotal: 'itemsTotal',
  Shipping: 'shipping',
  Tax: 'tax',
  Discount: 'discount',
} as const;

export interface PaymentBreakdown {
  itemsTotal: string;
  shipping?: string;
  tax?: string;
  discount?: string;
}

export type BreakdownTypesKeys = keyof typeof BreakdownTypes;
export type BreakdownTypesValues = (typeof BreakdownTypes)[BreakdownTypesKeys];
